import React from "react"
// react component for creating dynamic tables
import ReactTable from "react-table"

import * as Alert from "alertService"
import { APIPost, APIGet } from "services/APIRequest"
import UrlServer from "configs/UrlServer" 
import { ErrorsCallback, SuccessCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsUserUpdate } from "store/actions"
import { thaiBath } from "helpers/ConvertFormat"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// @material-ui/icons
import GroupIcons from "@material-ui/icons/Group"
import EventNoteIcons from "@material-ui/icons/EventNote"
// import Dvr from "@material-ui/icons/Dvr";
// import Favorite from "@material-ui/icons/Favorite";
import DeleteForeverIcons from "@material-ui/icons/DeleteForever"
// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import Button from "components/CustomButtons/Button.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardIcon from "components/Card/CardIcon.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import Select from "components/CustomSelects/Select.jsx"
import Switch from "@material-ui/core/Switch"
import Badge from "components/Badge/Badge.jsx"

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx"

const styles = {
  ...extendedFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  noConfirmedemail: {
    color: "red"
  },
  devType: {
    color: "#689F38"
  },
  tableH: {
    // marginTop: "30px",
    // marginBottom: "30px"
  }
}
class UserListManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      statusWaitingUpdate: true,
      dataListUserRaw: [],
      dataListUser: []
    }
  }
  componentDidMount() {
    // Alert.Loading()
    this.props.listsUserUpdate()
  }

  componentWillUpdate(nextProps, nextState) {
    // if (this.state.statusWaitingUpdate) {
    if (nextProps.listsUser !== nextState.dataListUserRaw) {
      var dataList = this.renderListData(nextProps)
      this.setState({
        statusWaitingUpdate: false,
        dataListUserRaw: nextProps.listsUser,
        dataListUser: dataList
      },()=>{
        Alert.LoadingClose()
      })
    }
  }
  handleUserViewDetail = (indexData)=>{
    this.props.callbacksetTabIndex(1)
    this.props.callbackSetCurrentUserData(this.state.dataListUserRaw[indexData])
  }

  renderListData = data => {
    var _userTypeObject = this.props.listUserType 
    var userTypeObject = {} 
    _userTypeObject.map((data)=>{
      userTypeObject[data.value] = data.name 
    })
    return data.listsUser.map((dataUser, key) => {
      return {
        id: (key + 1),
        fullName: dataUser.user_data_id.first_name + " " + dataUser.user_data_id.last_name,
        email: dataUser.user_data_id.email,
        userType:(
          <div className={this.props.classes.tableH} className={ "user_type_" + dataUser.user_type_code }>
            <Badge color={"info"}>{userTypeObject[dataUser.user_type_code]}</Badge>
          </div>),
        active: (
          <div>
            <Switch
              checked={dataUser.active}
              onChange={e => {
                this.handleChangeActive(dataUser._id, dataUser.user_data_id.first_name+" "+dataUser.user_data_id.last_name ,!dataUser.active)
              }}
              disabled={dataUser.user_type_code === 0 ? true : false}
              classes={{
                switchBase: this.props.switchBase,
                checked: this.props.switchChecked,
                icon: this.props.switchIcon,
                iconChecked: this.props.switchIconChecked,
                bar: this.props.switchBar
              }}
            />
          </div>
        ),
        actions: (
          <div className="actions-right">
            <Button
              // disabled={dataUser.user_type_code === 0 ? true : false}
              // justIcon
              round
              onClick={() => this.handleUserViewDetail(key)
              }
              color="info"
              className="remove"
            >
              <EventNoteIcons />ดูข้อมูล
            </Button>{" "}
            <Button
              disabled={dataUser.user_type_code === 0 ? true : false}
              justIcon
              round
              onClick={() =>
                this.handleDeleteUser(dataUser._id,dataUser.user_data_id.first_name+" "+dataUser.user_data_id.last_name)
              }
              color="danger"
              className="remove"
            >
              <DeleteForeverIcons />
            </Button>{" "}
          </div>
        )
      }
    })
  }
  handleChangeActive = (id,name, status) => {
    Alert.QuestionCallback("คุณต้องการเปลี่ยนสถานะการใช้งานของ " + name + " เป็น "+ status +" ใช่หรือไม่?","blue",()=>{
      const dataToSend = {
        _id:id,
        active:status
      }
      APIPost( UrlServer.URL_AUTH_USER_SET_ACTIVE,dataToSend,(datas)=>{
          this.props.listsUserUpdate()
      })
    })
  }
  handleDeleteUser = (id, name) => {
    Alert.QuestionCallback("คุณต้องการลบ " + name + " ใช่หรือไม่?","red",()=>{
      const dataToSend = {
        _id:id,
      }
      APIPost( UrlServer.URL_AUTH_USER_DELETE,dataToSend,(datas)=>{
        SuccessCallback(datas.message,null,()=>{
          this.props.listsUserUpdate()
        })
      })
    })
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card >
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <GroupIcons />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>จัดการผู้ใช้งานระบบ</h4>
              </CardHeader>
              <CardBody>
                <span>จำนวน {thaiBath(this.state.dataListUser.length,false)} รายการ</span> 
                <ReactTable
                  data={this.state.dataListUser}
                  filterable
                  columns={[
                    {
                      Header: "No.",
                      accessor: "id",
                      width: 50,
                    },
                    {
                      Header: "ชื่อ - สกุล",
                      accessor: "fullName"
                    },
                    {
                      Header: "อีเมล",
                      accessor: "email",
                      width: 200,
                    },
                    {
                      Header: "ประเภทผู้ใช้งาน",
                      accessor: "userType",
                      filterable: false
                    },
                    {
                      Header: "สถานะเปิดใช้งาน",
                      accessor: "active",
                      filterable: false
                    },
                    {
                      Header: "ตั้งค่าต่างๆ",
                      accessor: "actions",
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                  className="-striped -highlight"
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

function mapStateToProps({ listsUser }) {
  return {
    listsUser: listsUser
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsUserUpdate }
  )
)(UserListManagement)
